module.exports = __webpack_public_path__ + "static/media/offer_ad_image.8c505b0a.png";